var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3582_13754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2226 35.5608C43.7976 36.1051 43.1268 36.3985 42.4387 36.3422C41.7505 36.2856 41.1369 35.8865 40.8062 35.2803L38.5578 31.1582L33.3612 39.9827C33.0459 40.518 32.5052 40.8815 31.8906 40.9712C31.2759 41.0613 30.6537 40.8674 30.1987 40.4447L24.5604 35.2092L18.9219 43.9421L33.2791 58.421C33.6633 58.8083 34.1858 59.0268 34.7315 59.0278H34.7353C35.2795 59.0278 35.8013 58.8115 36.186 58.4265L58.6685 35.9152C59.8125 34.7696 60.7261 33.4794 61.4101 32.1031H46.9239L44.2226 35.5608Z",
    fill: "#EA1267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9492 28.0017H62.7361C63.4841 23.5022 62.1286 18.717 58.6689 15.253C55.912 12.4925 52.2463 10.9722 48.347 10.9722C44.4478 10.9722 40.7821 12.4925 38.0253 15.2528L34.8158 18.4664L31.6064 15.253C28.8494 12.4925 25.1837 10.9722 21.2846 10.9722C17.3854 10.9722 13.7197 12.4925 10.9628 15.253C5.27338 20.9496 5.27338 30.2188 10.9576 35.9102L15.9652 40.9603L12.1673 46.8425H2.05078C0.918203 46.8425 0 47.7607 0 48.8933C0 50.0259 0.918203 50.9441 2.05078 50.9441H13.2844C13.9807 50.9441 14.6296 50.5908 15.0073 50.0056L18.9223 43.9422L15.9655 40.9602L22.4416 30.9302C22.7705 30.4208 23.3079 30.083 23.9096 30.0077C24.5112 29.9325 25.1155 30.1273 25.5598 30.5398L31.1214 35.704L36.8596 25.96C37.2344 25.3237 37.9176 24.9343 38.6605 24.9502C39.3988 24.9623 40.0735 25.3704 40.4272 26.0186L42.9129 30.5757L44.3082 28.7898C44.6969 28.2922 45.293 28.0016 45.9242 28.0016L62.7361 28.0017C62.5014 29.4136 62.0595 30.7971 61.4105 32.1031H67.9492C69.0818 32.1031 70 31.1849 70 30.0524C70 28.9198 69.0818 28.0017 67.9492 28.0017Z",
    fill: "url(#paint0_linear_3582_13754)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3582_13754",
    x1: 35,
    y1: 10.9722,
    x2: 35,
    y2: 50.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF096D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D43751"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3582_13754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0b15ba5bc90c38826fe1aab12669b000.svg";
export { ForwardRef as ReactComponent };